if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // ✅ GET CHECKED ITEMS WITH CORRECT VARIANT IDS
        const checkedAddOns = document.querySelectorAll('.rebuy-addon__item-checkbox input[type="checkbox"]:checked');
        const addOnIds = [];

        checkedAddOns.forEach(checkbox => {
          // Get the parent .rebuy-addon__item element
          const itemContainer = checkbox.closest('.rebuy-addon__item');
          
          if (itemContainer) {
            // Look for variant ID in data attributes or the select/input fields
            let variantId = itemContainer.getAttribute('data-variant-id');
            
            // If not found, look for it in the dropdown or hidden field
            if (!variantId) {
              const selectElement = itemContainer.querySelector('select');
              if (selectElement && selectElement.value) {
                variantId = selectElement.getAttribute('data-variant-id') || selectElement.value;
              }
            }
            
            // If still not found, check for hidden inputs
            if (!variantId) {
              const hiddenInput = itemContainer.querySelector('input[type="hidden"]');
              if (hiddenInput) {
                variantId = hiddenInput.value;
              }
            }

            if (variantId) {
              addOnIds.push(variantId);
              console.log('✅ Found add-on variant ID:', variantId);
            } else {
              console.warn('⚠️ Could not find variant ID for checked item');
            }
          }
        });

        console.log('Main Product ID:', formData.get('id'));
        console.log('Checked Add-on IDs:', addOnIds);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        // ✅ ADD MAIN PRODUCT FIRST
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // ✅ THEN ADD CHECKED ADD-ONS
            if (addOnIds.length > 0) {
              this.addAddOnsToCart(addOnIds, 0, response);
            } else {
              this.finalizeAddToCart(response, formData.get('id'));
            }
          })
          .catch((e) => {
            console.error('Error adding main product:', e);
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // ✅ ADD ADD-ONS ONE BY ONE
      addAddOnsToCart(addOnIds, index, previousResponse) {
        if (index >= addOnIds.length) {
          this.finalizeAddToCart(previousResponse, null);
          return;
        }

        const addOnId = addOnIds[index];
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const addOnFormData = new FormData();
        addOnFormData.append('id', addOnId);
        addOnFormData.append('quantity', 1);

        if (this.cart) {
          addOnFormData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          addOnFormData.append('sections_url', window.location.pathname);
        }

        config.body = addOnFormData;

        console.log('🛒 Adding add-on to cart:', addOnId);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('✅ Add-on added successfully:', addOnId);
            this.addAddOnsToCart(addOnIds, index + 1, response);
          })
          .catch((e) => {
            console.error('❌ Error adding add-on:', addOnId, e);
            this.addAddOnsToCart(addOnIds, index + 1, previousResponse);
          });
      }

      // ✅ FINALIZE
      finalizeAddToCart(response, mainProductId) {
        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: mainProductId,
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });

        this.error = false;

        const quickAddModal = this.closest('quick-add-modal');

        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              });
            },
            { once: true }
          );

          quickAddModal.hide(true);
        } else {
          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(response);
          });
        }

        this.submitButton.classList.remove('loading');

        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }

        if (!this.error) this.submitButton.removeAttribute('aria-disabled');

        this.querySelector('.loading__spinner').classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}